import { useQuery } from '@tanstack/react-query';

import type { PendingGroupSubscriptionInvite } from '~/services/api/subscription/listPendingGroupSubscriptionInvites.server';

interface Props {
  enabled: boolean;
}

interface ReturnProps {
  isLoading: boolean;
  invites: PendingGroupSubscriptionInvite[];
}

const usePendingGroupInvites = ({ enabled }: Props): ReturnProps => {
  const { data, isLoading } = useQuery({
    queryKey: ['pending-group-invites'],
    queryFn: async (): Promise<PendingGroupSubscriptionInvite[]> => {
      const response = await fetch('/pending_group_invites');
      if (!response.ok) {
        throw new Error('Failed to load pending group invites');
      }
      return response.json();
    },
    enabled,
  });

  return {
    isLoading: isLoading && enabled,
    invites: data ?? [],
  };
};

export default usePendingGroupInvites;
